import axios from "axios";
import buildUrl from 'build-url-ts';
import { UserRole } from "src/types/settings/userRoles";

const BASE_URL = process.env.REACT_APP_API_URL;
const USER_ROLES_BASE_URL = `${BASE_URL}/api/2.0/user_roles`;

export const userRolesApi = {
 fetchUserRolesForAccount : async () => {
    const url = buildUrl(`${USER_ROLES_BASE_URL}/all`);
    const response = await axios.get(url);
    return response.data as UserRole[];
  },
  fetchUserRoles : async (id: string) => {
    const url = buildUrl(`${USER_ROLES_BASE_URL}/${id}`);
    const response = await axios.get(url);
    return response.data as UserRole;
  },
  updateUserRoles : async (id: string, data: any) => {
    const url = buildUrl(`${USER_ROLES_BASE_URL}/${id}`);
    const response = await axios.put(url, data);
    return response.data as UserRole;
  },
  createUserRole : async (data: any) => {
    const url = buildUrl(`${USER_ROLES_BASE_URL}`);
    const response = await axios.post(url, data);
    return response.data as UserRole;
  },
  deleteUserRole : async (id: string) => {
    const url = buildUrl(`${USER_ROLES_BASE_URL}/${id}`);
    const response = await axios.delete(url);
    return response.data;
  }
};